module.exports = __webpack_public_path__ + "img/icon-dashed.dbacd45f.svg";